import { SNACKBAR_DURATION } from '../../../../shared/constants/snackbar.constants';
import { Component, inject } from '@angular/core';
import {MatButton, MatIconButton} from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
} from '@angular/material/dialog';
import {MatIcon} from '@angular/material/icon';

import {FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {GenRoleDefinition} from '../../../../generated/serverModels/GenRoleDefinition';
import {MatCheckbox} from '@angular/material/checkbox';
import {RoleNamePipe} from '../../../../shared/pipes/role-name.pipe';
import {UserService} from '../../../../services/user.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {User} from '../../../../core/classes/user';

interface Checkboxes {
  checkboxes: FormArray
}

@Component({
  selector: 'tgrid-edit-roles-modal',
  imports: [
    MatButton,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatIcon,
    MatIconButton,
    ReactiveFormsModule,
    MatCheckbox,
    RoleNamePipe,
],
  templateUrl: './edit-roles-modal.component.html',
  standalone: true,
  styleUrls: ['../../../../../style/modal.scss', './edit-roles-modal.component.scss'],
})


export class EditRolesModalComponent {
  private dialogRef = inject<MatDialogRef<EditRolesModalComponent>>(MatDialogRef);
  data = inject<{
    user: User;
}>(MAT_DIALOG_DATA);


  private userService = inject(UserService);
  private snackbar = inject(MatSnackBar);

  get checkboxControls(): FormControl[] {
    return this.checkboxGroup.controls.checkboxes.controls as FormControl[];
  }

  protected selectableRoles = GenRoleDefinition.values().filter(role => {
    return ![GenRoleDefinition.ROLE_RESETTING_PASSWORD].includes(role);
  });

  private fb = inject(FormBuilder);
  protected checkboxGroup: FormGroup<Checkboxes> = new FormGroup<Checkboxes>({
    checkboxes: new FormArray<FormControl>([]),
  });

  constructor() {
    const data = this.data;


    const controls = this.selectableRoles.map(possibleRole => {
      const isSelected = data.user.roles.includes(possibleRole);
      return this.fb.control(isSelected);
    });

    this.checkboxGroup.setControl('checkboxes', this.fb.array(controls));
  }


  protected updateRoles(): void {
    const updatedRoles: GenRoleDefinition[] = [];
      this.checkboxControls.forEach((control, i) => {
      if(control.value) {
        updatedRoles.push(this.selectableRoles[i]);
      }
    });
      this.data.user.roles = updatedRoles;

    this.userService.updateRoles(this.data.user).subscribe({
      next: () => {
        this.snackbar.open('User roles updated', 'X', {duration: SNACKBAR_DURATION.MEDIUM});
        this.dialogRef.close(updatedRoles);
      },
      error: () => {
        this.snackbar.open('Failed to update user roles', 'X', {duration: SNACKBAR_DURATION.MEDIUM});
      },
    });

  }
}
